//#region Styles
import { Column, Row, SubtitleSection } from "components/styles";
import { FormFields } from "../../styles";
//#endregion
//#region Components
import HandlerCheckbox from "components/CustomCheckbox/CustomCheckbox";
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import LabelForm from "components/LabelForm/LabelForm";
import NoRecordsMessage from "../NoRecordsMessage/NoRecordsMessage";
import ScheduleRecords from "./components/ScheduleRecords/ScheduleRecords";
import Footer from "../Footer/Footer";
//#endregion
//#region Services
import { requestCreateResourceSchedule, requestDeleteResourceSchedule } from "services/settings/scheduleAdmin/aboutScheduleAdmin";
//#endregion
//#region Utils
import { GET_DIALOG_ERROR_NOTIFICATION_PROPS, GET_DIALOG_SAVE_PROPS, SAVE_TYPE } from "../Dialogs/constants";
import useMainContext from "utils/context/useMainContext";
import useScheduleForm from "./utils/hooks/useScheduleForm";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import useSettingsResourceScheduleAdminContext from "views/Configuracion/SettingsResourceScheduleAdmin/context/useSettingsResourceScheduleAdminContext";
//#endregion

const ScheduleForm = ({
    filters, registerScheduleData,
    openDialogConfirmSave,
    openDialogConfirmDelete, 
    openDialogErrorNotification,
    cancelRegisterSchedule
}) => {
    const mainContext = useMainContext();
    const { loadingRequest, data } = useSettingsResourceScheduleAdminContext();
    const form = useScheduleForm();
    //#region Functions
    const getCheckboxProps = ({ id, name }) => {
        return {
            value: id, label: name,
            padding: "5px",
            checked: form.isDaySelected(id)
        };
    }
    const saveSchedule = async () => {
        loadingRequest.show("Registrando horario de atención...");
        const { success, message, days } = await requestCreateResourceSchedule({
            ...filters.value,
            ...form.value
        });
        loadingRequest.hide();
        if (success) {
            form.clear();
            registerScheduleData.fill();
            return;
        }
        if (message) {
            openDialogErrorNotification(GET_DIALOG_ERROR_NOTIFICATION_PROPS[message](days));
            return;
        }
        mainContext.setShowDialogUnexpectedError(true);
    }
    const deleteSchedule = async ({ id, dayName }) => {
        loadingRequest.show("Eliminando horario de atención...");
        const { success, message } = await requestDeleteResourceSchedule(id);
        loadingRequest.hide();
        if (success) {
            registerScheduleData.fill();
            return;
        }
        if (message) {
            openDialogErrorNotification(GET_DIALOG_ERROR_NOTIFICATION_PROPS[message](dayName));
            return;
        }
        mainContext.setShowDialogUnexpectedError(true);
    }
    const triggerSave = () => {
        if (!form.validate())
            return;
        openDialogConfirmSave({
            props: GET_DIALOG_SAVE_PROPS[SAVE_TYPE.SCHEDULE](),
            saveAction: saveSchedule
        });
    }
    //#endregion
    const { schedules } = registerScheduleData;
    return (
        <FormFields>
            <HandlerCheckbox 
                checkboxProps={data.allDays.map(getCheckboxProps)}
                gap="5px"
                onChange={form.setDays}
                description="Día(s)"
                required/>
            <Column>
                <LabelForm text="Horario" required/>
                <Row justifyContent="flex-start">
                    <CustomTime 
                        label="Desde"
                        caption="Desde:"
                        value={form.value.timeStart}
                        onChange={form.setTimeStart}/>
                    <CustomTime 
                        label="Hasta"
                        caption="Hasta:"
                        value={form.value.timeEnd}
                        onChange={form.setTimeEnd}/>
                </Row>
                <ErrorMessage
                    error={form.errors.schedule !== null}
                    text={form.errors.schedule} />
            </Column>
            {schedules.length === 0 
            ? <NoRecordsMessage/>
            : <Column marginTop="8px">
                <SubtitleSection
                    fontWeight="bold" 
                    fontSize="15px">Registros</SubtitleSection>
                <ScheduleRecords 
                    deleteSchedule={deleteSchedule}
                    openDialogConfirmDelete={openDialogConfirmDelete}
                    schedules={schedules}/>
            </Column>}
            <Footer 
                save={triggerSave}
                cancel={cancelRegisterSchedule}
                completedForm={form.isCompleted}/>
        </FormFields>
    );
}

export default ScheduleForm;